import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Error404 from '../errors/Error404';
import { unavailableFeatureRouteMap } from '../../routes';

const UnavailableFeature = ({ location }) => {
  const routeMeta = unavailableFeatureRouteMap[location.pathname] || {};
  const featureName = routeMeta.name || 'Bo`lim';
  const sectionName = routeMeta.section || 'Menyu';

  return (
    <Error404
      eyebrow={`${sectionName} bolimi`}
      codeLabel="404"
      title={`${featureName} sahifasi hali tayyor emas`}
      description={`${featureName} uchun ichki modul hali ishlab chiqilmagan. Menyu manzili endi toza slug bilan ishlaydi, lekin kontent tayyor bolmagani uchun ushbu glass fallback sahifa korsatildi.`}
      panelTitle="Keyingi qadam"
      panelDescription="Bu bolim uchun sahifa tayyor bolgach, shu manzilning ozida ochiladi. Hozircha dashboard yoki boshqa tayyor menyuga qaytishingiz mumkin."
      homeLabel="Dashboard ga qaytish"
      backLabel="Orqaga qaytish"
    />
  );
};

UnavailableFeature.propTypes = {
  location: PropTypes.object.isRequired
};

export default withRouter(UnavailableFeature);
